import { render, staticRenderFns } from "./taxes.vue?vue&type=template&id=dd84e3be&scoped=true"
import script from "./taxes.vue?vue&type=script&lang=js"
export * from "./taxes.vue?vue&type=script&lang=js"
import style0 from "./taxes.vue?vue&type=style&index=0&id=dd84e3be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd84e3be",
  null
  
)

export default component.exports